import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isActive',
    standalone: false,
})
export class IsActivePipe implements PipeTransform {
    transform<TData extends { active: boolean }>(
        collection: TData[],
        condition: boolean,
    ): TData[] {
        return collection.filter((x) => x.active === condition);
    }
}
